export default {
    getShifts: { method: 'get', url: 'shifts' },
    postShifts: { method: 'post', url: 'shifts' },
    updateShifts: { method: 'put', url: 'shifts/{id}' },
    deleteShifts: { method: 'delete', url: 'shifts/{id}' },
}